import React, { useState, useMemo } from "react";
import { IReducer } from "../../state/reducer";
import PrimaryFilter from "../PrimaryFilter/PrimaryFilter";
import SetRow from "../SetRow/SetRow";
import "./sets.css";

const Sets: React.FC<IReducer> = ({ state, dispatch }) => {
  const [activeSearch, setActiveSearch] = useState<string>("");

  // Memoized computation of visible sets
  const visibleSets = useMemo(() => {
    let filteredSets: string[] = []; // Array of set IDs

    state.sets.forEach((setEntry, setId) => {
      if (setEntry && setEntry.visible && !setEntry.userHidden) {
        filteredSets.push(setId);
      }
    });

    // Apply search filter
    if (activeSearch.trim() !== "") {
      filteredSets = filteredSets.filter((setId) => {
        const set = state.sets.get(setId);
        return (
          set &&
          (set.name.toLowerCase().includes(activeSearch.toLowerCase()) ||
            set.id.toLowerCase().includes(activeSearch.toLowerCase()))
        );
      });
    }

    return filteredSets;
  }, [state.sets, activeSearch]);

  // Only render if there are visible sets
  return visibleSets.length > 0 ? (
    <div className="moduleContainer">
      <div className="setContainer">
        <div className="setHeader">
          <div className="setHeaderTitle">Sets</div>
        </div>
        <div className="setsContainer">
          {visibleSets.map((setId) => (
            <SetRow
              key={setId}
              setId={setId}
              state={state}
              dispatch={dispatch}
            />
          ))}
        </div>
        <div className="setFooter">
          <PrimaryFilter
            placeholder="Search"
            setActiveSearch={setActiveSearch}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default Sets;
